<template>
  <v-container grid-list-xl class="ma-0 pa-5">
    <v-card class="banner rounded-lg elevation-0 pa-5 mt-5">
      <v-row class="lg-mt-5">
        <v-col md="6" lg="7" cols="12" class="px-5">
          <div>
            <p class="headline primary--text font-weight-medium my-1">Program E-Learning Guru Penggerak</p>
            <p class="body-1  primary--text">
              Program E-learning Guru penggerak merupakan program untuk mengelola kelas Guru penggerak.
            </p>
          </div>
          <m-button
            depressed
            class="secondary my-4"
            :text="this.current_instansi.nama"
            icon="mdi-swap-horizontal-bold"
            action="pilih"
            @pilih="pilih()"
          ></m-button>
        </v-col>
        <v-col md="1" lg="1" cols="12"></v-col>
        <v-col md="5" lg="4" cols="12">
          <div style="position:relative" class="d-none d-md-flex d-lg-flex">
            <v-img
              fluid
              style="position:absolute; top:-20px; right:12%; max-width:250px"
              class="mb-5"
              src="https://penggerak-cdn.siap.id/s3/gurupenggerak/hero-gp.png"
            ></v-img>
          </div>
        </v-col>
      </v-row>
    </v-card>
    <PilihDialog ref="dlgInstansi" />
  </v-container>
</template>

<script>
import BlockCard from "@/components/BlockCard";
import PilihDialog from "../../instansi/components/PilihInstansiDialog";
export default {
  components: {
    BlockCard,
    PilihDialog
  },
  data() {
    return {};
  },
  mounted() {
    // this.items[0].description = "Hai, " + this.current_user.nama;
  },
  methods: {
    toAction(action) {
      this.$router.push({
        name: action
      });
    },
    pilih() {
      this.$refs.dlgInstansi
        .open()

        .then(res => res)
        .catch(e => e);
    }
  },
  filters: {
    capitalize: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  computed: {}
};
</script>
<style>
.transparent {
  background-color: transparent !important;
  border-color: transparent !important;
}
</style>
